import { render, staticRenderFns } from "./Specificities.vue?vue&type=template&id=29721050"
import script from "./Specificities.vue?vue&type=script&lang=ts"
export * from "./Specificities.vue?vue&type=script&lang=ts"
import style0 from "./Specificities.vue?vue&type=style&index=0&id=29721050&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports